// Feature State Enum
export enum FeatureState {
    Disable = 0,  // Disable for all system
    Enable = 1,   // Enable for all system
    Beta = 2      // Find details in FeaturePermissions
}

// Feature Interface
export interface IFeature {
    id?: number;
    title?: string;
    state?: FeatureState;
    description?: string;
    modifiedAt?: Date | string;
}

// Feature Permission Interface
export interface IFeaturePermission {
    id?: number;
    featureId?: number;
    principal?: string; // user, group, or role name; multiple IDs can be separated by ";"
    modifiedAt?: Date | string;
}

// Feature with Permissions (for display)
export interface IFeatureWithPermissions extends IFeature {
    Permissions?: IFeaturePermission[];
}

// Helper function to get state display name
export const getFeatureStateLabel = (state: FeatureState): string => {
    switch (state) {
        case FeatureState.Disable:
            return 'Disabled';
        case FeatureState.Enable:
            return 'Enabled';
        case FeatureState.Beta:
            return 'Beta';
        default:
            return 'Unknown';
    }
};

// Helper function to get state color
export const getFeatureStateColor = (state: FeatureState): string => {
    switch (state) {
        case FeatureState.Disable:
            return '#d13438'; // Red
        case FeatureState.Enable:
            return '#107c10'; // Green
        case FeatureState.Beta:
            return '#ffb900'; // Yellow
        default:
            return '#605e5c'; // Gray
    }
};

// Helper functions for handling semicolon-separated principals
export const splitPrincipals = (principal: string): string[] => {
    return principal.split(';').map(p => p.trim()).filter(p => p.length > 0);
};

export const joinPrincipals = (principals: string[]): string => {
    return principals.filter(p => p.trim().length > 0).join(';');
};

export const getPrincipalDisplayText = (principal: string): string => {
    const principals = splitPrincipals(principal);
    if (principals.length > 1) {
        return `${principals.length} principals: ${principals.join(', ')}`;
    }
    return principal;
};
